import {connect} from 'react-redux';

import AdditionalScores from '../AdditionalScores.jsx';

function select(state, props) {
    const additionalScores = props.additionalScores;
    const scores = state.application.getIn(['live', 'scores']);

    return {
        ...props,
        additionalScores,
        scores
    };
}

export default connect(select)(AdditionalScores);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/AdditionalScores.jsx